import { render, staticRenderFns } from "./BaseTransitionView.vue?vue&type=template&id=14531896&scoped=true&"
import script from "./BaseTransitionView.vue?vue&type=script&lang=js&"
export * from "./BaseTransitionView.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransitionView.vue?vue&type=style&index=0&id=14531896&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14531896",
  null
  
)

export default component.exports